"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = rgbaToHex;

var _ = require(".");

function pad2(c) {
  return c.length === 1 ? "0".concat(c) : "".concat(c);
}

function rgbaToHex(color) {
  var rgbaColor = (0, _.decomposeColor)(color);

  if (rgbaColor.type !== 'rgba') {
    return '';
  }

  var hex = [pad2(Math.round(rgbaColor.values[0]).toString(16)), pad2(Math.round(rgbaColor.values[1]).toString(16)), pad2(Math.round(rgbaColor.values[2]).toString(16))];
  return hex.join('');
}